import { createSlice } from '@reduxjs/toolkit';

// UI state for the "Ask Reggie" drawer. The drawer is global to the Analytics
// section; individual analytics pages can publish what the user is looking at
// (page label, date range, active filters) so answers are anchored to it.

const defaultContext = {
  page: 'Analytics',
  label: 'Analytics',
  filters: {},
  dateRange: null,
};

const rhinoanalystSlice = createSlice({
  name: 'RHINOANALYST',
  initialState: {
    isOpen: false,
    context: defaultContext,
  },
  reducers: {
    openAskReggie: (state) => ({ ...state, isOpen: true }),
    closeAskReggie: (state) => ({ ...state, isOpen: false }),
    toggleAskReggie: (state) => ({ ...state, isOpen: !state.isOpen }),
    setAskReggieContext: (state, action) => ({
      ...state,
      context: { ...defaultContext, ...(action.payload || {}) },
    }),
    clearAskReggieContext: (state) => ({ ...state, context: defaultContext }),
  },
});

export default rhinoanalystSlice.reducer;

export const {
  openAskReggie,
  closeAskReggie,
  toggleAskReggie,
  setAskReggieContext,
  clearAskReggieContext,
} = rhinoanalystSlice.actions;

export const getAskReggieState = (state) => state.rhinoanalyst;
